import { render, staticRenderFns } from "./ReChannelSmall.vue?vue&type=template&id=52d09e7a&scoped=true"
import script from "./ReChannelSmall.vue?vue&type=script&lang=js"
export * from "./ReChannelSmall.vue?vue&type=script&lang=js"
import style0 from "./ReChannelSmall.vue?vue&type=style&index=0&id=52d09e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d09e7a",
  null
  
)

export default component.exports